function emptyPlan() {
    return {
        fuzzyTerms: [],
        exactPhrases: [],
        predicates: [],
        negations: [],
        unions: [],
    };
}
/**
 * Recursively walk an AST node and accumulate signals into the given plan.
 *
 * - fuzzy → fuzzyTerms
 * - phrase → exactPhrases
 * - predicate → predicates
 * - and → recurse into all children, accumulating into THIS plan
 * - or → recurse into each child as its own sub-plan, push to unions
 * - not → recurse into child as its own sub-plan, push to negations
 */
function walk(node, plan) {
    switch (node.kind) {
        case "fuzzy":
            plan.fuzzyTerms.push(node.value);
            return;
        case "phrase":
            plan.exactPhrases.push(node.value);
            return;
        case "predicate":
            plan.predicates.push({
                field: node.field,
                value: node.value,
                quoted: node.quoted,
            });
            return;
        case "and":
            for (const child of node.children)
                walk(child, plan);
            return;
        case "or":
            for (const child of node.children) {
                const sub = emptyPlan();
                walk(child, sub);
                plan.unions.push(sub);
            }
            return;
        case "not": {
            const sub = emptyPlan();
            walk(node.child, sub);
            plan.negations.push(sub);
            return;
        }
    }
}
export function compile(parsed) {
    const plan = emptyPlan();
    walk(parsed.ast, plan);
    return plan;
}
/**
 * True iff the plan has no signals at all (input was empty/whitespace/junk).
 *
 * A "blank" plan should typically return zero hits, not all hits — explicit
 * "list everything" must be opt-in via a separate code path.
 */
export function isPlanEmpty(plan) {
    return (plan.fuzzyTerms.length === 0 &&
        plan.exactPhrases.length === 0 &&
        plan.predicates.length === 0 &&
        plan.negations.length === 0 &&
        plan.unions.length === 0);
}
//# sourceMappingURL=compiler.js.map